import { useColorTheme } from '@/hooks/domain/useColor';

type Props = {
  size?: string;
};

const SlackIcon = (props: Props) => {
  const colorTheme = useColorTheme();

  return (
    <img
      src={
        colorTheme === 'dark'
          ? `/assets/logo-slack_dark.svg`
          : `/assets/logo-slack.svg`
      }
      alt="slack"
      width={props.size || '24px'}
      height={props.size || '24px'}
    />
  );
};

export default SlackIcon;
